import { Route, Routes } from 'react-router-dom'
import MainLayout from './components/MainLayout'
import AboutPageV2 from './pages/AboutPageV2'
import ContactPageV2 from './pages/ContactPageV2'
import HomePageV2 from './pages/HomePageV2'
import PortfolioPage from './pages/PortfolioPage'
import PrivacyPage from './pages/PrivacyPage'
import ServicesPageV2 from './pages/ServicesPageV2'
import StatusPageV2 from './pages/StatusPageV2'

export default function App() {
  return (
    <Routes>
      <Route element={<MainLayout language="el" />}>
        <Route path="/" element={<HomePageV2 />} />
        <Route path="/services" element={<ServicesPageV2 />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/about" element={<AboutPageV2 />} />
        <Route path="/contact" element={<ContactPageV2 />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/thank-you" element={<StatusPageV2 type="thankYou" />} />
        <Route path="*" element={<StatusPageV2 type="notFound" />} />
      </Route>
      <Route path="/en" element={<MainLayout language="en" />}>
        <Route index element={<HomePageV2 />} />
        <Route path="services" element={<ServicesPageV2 />} />
        <Route path="portfolio" element={<PortfolioPage />} />
        <Route path="about" element={<AboutPageV2 />} />
        <Route path="contact" element={<ContactPageV2 />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="thank-you" element={<StatusPageV2 type="thankYou" />} />
        <Route path="*" element={<StatusPageV2 type="notFound" />} />
      </Route>
    </Routes>
  )
}
